import { OfficeTransferProofItem } from "@/type/core/officeTransfer/officeTransfer.types";
import BasicLink from "@components/core/links/BasicLink";
import DownloadIcon from "@static/core/icons/icon-download.svg?react";
import ViewIcon from "@static/core/icons/icon-view.svg?react";
import { getToken } from "@utils/helpers/api.helper";
import { ColumnsType } from "antd/lib/table/interface";
import i18n from "i18next";

export const columns = (): ColumnsType<OfficeTransferProofItem> => [
  {
    dataIndex: "fileName",
    render: (fileName: string) => {
      return (
        <span title={fileName}>
          {fileName}
          {/* 
          // filesize does not exist on OfficeTransferProofItem
          {record.fileSize && (
            <span className="ml-8"> {record.fileSize} Ko</span>
          )} */}
        </span>
      );
    },
  },
  {
    dataIndex: "path",
    width: 54,
    render: (path: string) => {
      const viewUrl = path + "?token=" + getToken();
      return path ? (
        <BasicLink
          to={viewUrl + "&download=false"}
          title={i18n.t("buttons.open")}
        >
          <ViewIcon className="icon-30 text-black" />
        </BasicLink>
      ) : (
        <></>
      );
    },
  },
  {
    dataIndex: "path",
    width: 54,
    render: (path: string, record: OfficeTransferProofItem) => {
      const viewUrl = path + "?token=" + getToken();
      return path ? (
        <BasicLink
          to={viewUrl + "&download=true"}
          target="_blank"
          download={record.fileName}
          title={i18n.t("buttons.download")}
        >
          <DownloadIcon className="icon-30 text-black" />
        </BasicLink>
      ) : (
        <></>
      );
    },
  },
];
